import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * Model description here for TypeScript hints.
 */
export const TokenModel = types
  .model("Token")
  .props({
    token_type: types.maybeNull(types.string),
    expires_in: types.maybeNull(types.number),
    access_token: types.string,
    refresh_token: types.maybeNull(types.string)
  })
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key, value) {
      self[key] = value
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type TokenType = Instance<typeof TokenModel>
export interface Token extends TokenType {}
type TokenSnapshotType = SnapshotOut<typeof TokenModel>
export interface TokenSnapshot extends TokenSnapshotType {}
export const createTokenDefaultModel = () => types.optional(TokenModel, {})
